<div *ngIf="page_loader" class="pay-loader"></div>

<div [hidden]="page_loader" class="payment-wrapper">
  <app-main-payment [isStandAlone]="true" [fundraiser]="fundraiser" origin="ps" type="full"></app-main-payment>
</div>